import axios from '../../helpers/axios-setup';

export const resendSalesforceApiCall = (id: number) => axios.get(`admin/billing/resend/${id}`);
